<template>
  <div v-loading="pageLoading" class="dialog-order-list">
    <el-table
      ref="dialogOrderList"
      :data="items"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @row-dblclick="rowDblClick"
    >
      <el-table-column>
        <el-table-column :label="$t('planning.group')">
          <template slot-scope="scope">
            <span>{{ getPlanningOptionTranslation(scope.row['planningOption']) }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column :label="$t('planning.total')">
        <el-table-column :label="$t('planning.amount')">
          <template slot-scope="scope">
            <span>{{
              scope.row['totalAmount']['amount'] + ' ' + getPlanningOptionUnitTranslation(scope.row['planningOption'])
            }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('planning.orderAmount')">
          <template slot-scope="scope">
            <span>{{ scope.row['totalAmount']['amountOfOrders'] }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column :label="$t('planning.noStock')">
        <el-table-column :label="$t('planning.amount')">
          <template slot-scope="scope">{{
            scope.row['noStockAmount']['amount'] + ' ' + getPlanningOptionUnitTranslation(scope.row['planningOption'])
          }}</template>
        </el-table-column>

        <el-table-column :label="$t('planning.orderAmount')">
          <template slot-scope="scope">
            <span>{{ scope.row['noStockAmount']['amountOfOrders'] }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column :label="$t('planning.toPlan')">
        <el-table-column :label="$t('planning.amount')">
          <template slot-scope="scope">{{
            scope.row['toPlanAmount']['amount'] + ' ' + getPlanningOptionUnitTranslation(scope.row['planningOption'])
          }}</template>
        </el-table-column>

        <el-table-column :label="$t('planning.orderAmount')">
          <template slot-scope="scope">
            <span>{{ scope.row['toPlanAmount']['amountOfOrders'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('planning.oldestOrder')">
          <template slot-scope="scope">
            <span>{{ toDateStringInternal(scope.row['oldestOrder']) }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { closeCurrentTag } from '@/utils/tags';
import { PlanningOption } from '@/utils/constants';
import { formatDateByElementFormat } from '@/utils/date';

export default {
  name: 'OrdersToPlan',
  props: {
    entity: {
      default: '',
      type: String
    },
    permissionCode: String,
    domainID: {
      default: 0,
      type: Number
    },
    inPlanning: {
      default: false,
      type: Boolean
    },
    planningOption: {
      type: Number
    }
  },
  data() {
    return {
      pageLoading: false,
      dialogVisible: true,
      amountString: '',
      items: [],
      multipleSelection: [],

      orderNumbers: [],
      orderNumberToAdd: '',
      showOrderNumberError: false,
      // order line status update
      fromStatusID: null,
      toStatusID: null,
      estimatedDeliveryDate: null
    };
  },
  computed: {
    dateFormat() {
      return this.$store.getters.dateFormat;
    },
    dateTimeFormat() {
      return this.$store.getters.dateTimeFormat;
    }
  },
  watch: {
    domainID() {
      this.getOrdersToPlan();
    }
  },
  async created() {
    this.getOrdersToPlan();
  },
  methods: {
    toDateStringInternal(date) {
      return date && formatDateByElementFormat(date, 'DD-MM-YYYY');
    },
    close() {
      closeCurrentTag(this);
    },
    getOrdersToPlan() {
      this.pageLoading = true;
      this.$store
        .dispatch('productionPlanning/getOrdersToPlan', {
          domainID: this.domainID
        })
        .then(data => {
          this.items = data;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    rowDblClick(row) {},
    getPlanningOptionTranslation(planningOption) {
      switch (planningOption) {
        case PlanningOption.Panel:
          return this.$i18n.t('planning.panels');
        case PlanningOption.NetCurtainRoomHigh:
          return this.$i18n.t('planning.netCurtainsRoomHigh');
        case PlanningOption.CurtainRoomHigh:
          return this.$i18n.t('planning.curtainsRoomHigh');
        case PlanningOption.Cutting:
          return this.$i18n.t('planning.cuttings');
        case PlanningOption.RomanBlind:
          return this.$i18n.t('planning.romanBlinds');
      }
    },
    getPlanningOptionUnitTranslation(planningOption) {
      switch (planningOption) {
        case PlanningOption.Panel:
          return this.$i18n.t('planning.panels');
        case PlanningOption.NetCurtainRoomHigh:
        case PlanningOption.CurtainRoomHigh:
        case PlanningOption.Cutting:
          return this.$i18n.t('planning.meters');
        case PlanningOption.RomanBlind:
          return this.$i18n.t('planning.pieces');
      }
    },

    handleClose(orderNumber) {
      this.orderNumbers.splice(this.orderNumbers.indexOf(orderNumber), 1);
    }
  }
};
</script>
